export const SAMPLE_EMPTY_OBJECT = {} as const;

/* prettier-ignore */
export const SAMPLE_OBJECTS = [
	SAMPLE_EMPTY_OBJECT,
	{ key: "value" },
] as const;
